export const users = {
  _title: 'Utilisateurs',
  _menuTitle: 'Utilisateurs & rôles',
  roles: 'Rôles',
  scope: 'Périmètre',
  admin: 'Admin',
  permissions: 'Permissions',
  createUser: 'Créer un utilisateur',
  disableUser: 'Désactiver un utilisateur',
  createRole: 'Créer un rôle',
  deleteRole: 'Supprimer un rôle',
  userIsDisabled: "Cet utilisateur est désactivé car il n'a aucun rôle associé.",
  disabledUsers: 'Utilisateurs désactivés',
  lackingPermission: 'Permission manquante',
  allScopes: {
    cms: 'Tous les CMS',
    beneficiariesIds: 'Tous les ayants-droits',
    youtubeChannelsIds: 'Toutes les chaînes YouTube',
  },
  scopeKeys: {
    cms: 'CMS',
    beneficiariesIds: 'Ayants-droits',
    youtubeChannelsIds: 'Chaînes Youtube',
  },
  permissionsList: {
    generic: 'Permission',
    'beneficiaries.read': 'Voir les ayants-droits',
    'beneficiaries.edit': 'Éditer les ayants-droits',
    'products.read': 'Voir les collections',
    'products.edit': 'Éditer les collections',
    'artworks.read': 'Voir les œuvres',
    'artworks.edit': 'Éditer les œuvres',
    'youtubeChannels.read': 'Voir les chaînes Youtube',
    'youtubeChannels.edit': 'Éditer les chaînes Youtube',
    'youtubeClaimsAssets.read': 'Voir les claims Youtube',
    'youtubeClaimsAssets.edit': 'Éditer les claims Youtube',
    'beneficiary_rates.edit': 'Éditer les taux spécifiques',
    'compilations.read': 'Voir les compilations',
    'compilations.edit': 'Éditer les compilations',
    'imports.edit': 'Voir et éditer les rapports de vente',
    'statements.read': 'Voir les statements',
    'statements.edit': 'Éditer les statements',
    'auto_monetization.read': 'Voir la monétisation auto.',
    'monetization_patterns.edit': 'Gérer les routines de monétisation',
    'auto_translation.read': 'Voir les traductions auto.',
    'auto_translation.edit': 'Éditer les traductions auto.',
    'video_promotion.read': 'Voir les promotions de vidéos',
    'video_promotion.edit': 'Éditer les promotions de vidéos',
    'file_copy.read': 'Voir les copies de fichiers',
    'file_copy.edit': 'Lancer des copies de fichiers',
    'scam_export.read': 'Accès aux exports SCAM',
    'youtubeQuotas.read': 'Accès aux quotas YouTube API',
    'media_uploader.access': 'Accéder au Media Uploader',
    'media_uploader.cold_storage_access': 'Accéder aux fichiers stockés en Cold Storage',
    'content_id.edit': "Dépôt d'empreinte de protection (Content ID)",
    'dataviz.read': 'Voir les performances',
    'roles.read': 'Voir les rôles',
    'roles.edit': 'Éditer les rôles',
    'users.edit': 'Créér et éditer les utilisateurs',
    'user_roles.read': 'Voir les rôles des utilisateurs',
    'user_rights.edit': 'Éditer les rôles et périmètres des utilisateurs',
  },
  rolesPermissions: {
    'youtubeChannels.read': {
      title: 'Voir',
      description: 'Voir les attributs des chaînes Youtube',
    },
    'youtubeChannels.edit': {
      title: 'Éditer',
      description: 'Éditer les attributs des chaînes Youtube',
    },
    'beneficiaries.read': {
      title: 'Voir',
      description: 'Voir les attributs des ayants-droits (PAS les taux)',
    },
    'beneficiaries.edit': {
      title: 'Éditer',
      description: 'Éditer les attributs des ayants-droits (PAS les taux)',
    },
    'products.read': {
      title: 'Voir',
      description: 'Voir les attributs des collections',
    },
    'products.edit': {
      title: 'Éditer',
      description: 'Éditer les attributs des collections',
    },
    'artworks.read': {
      title: 'Voir',
      description: 'Voir les attributs des oeuvres',
    },
    'artworks.edit': {
      title: 'Éditer',
      description: 'Éditer les attributs des oeuvres',
    },
    'youtubeClaimsAssets.read': {
      title: 'Voir',
      description: 'Voir les claims Youtube',
    },
    'youtubeClaimsAssets.edit': {
      title: 'Éditer',
      description: 'Éditer les claims Youtube',
    },
    'beneficiary_rates.edit': {
      title: 'Éditer les taux',
      description: "Éditer les taux d'un ayant droit ou d'une collection",
    },
    'compilations.read': {
      title: 'Voir',
      description: 'Lister les compilations',
    },
    'compilations.edit': {
      title: 'Éditer',
      description: 'Éditer les compilations',
    },
    'imports.edit': {
      title: 'Voir et Éditer',
      description: 'Lister, importer et corriger des rapports de vente',
    },
    'statements.read': {
      title: 'Voir',
      description:
        'Lister les statements (et les taux, les avances, les lignes de statements, faire les exports etc...)',
    },
    'statements.edit': {
      title: 'Éditer',
      description: "Éditer des avances, ajouter des lignes d'ajustements, calculer les statements",
    },
    'auto_monetization.read': {
      title: 'Monétisation auto.',
      description: 'Lister les vidéos monétisées automatiquement ',
    },
    'monetization_patterns.edit': {
      title: 'Routines de monétisation',
      description: 'Créer, modifier et supprimer les routines de coupures publicitaires',
    },
    'auto_translation.read': {
      title: 'Traduction auto. - Voir',
      description: 'Lister les traductions de vidéos',
    },
    'auto_translation.edit': {
      title: 'Traduction auto. - Éditer',
      description: "(Re)lancer la traduction d'une vidéo",
    },
    'video_promotion.read': {
      title: 'Voir',
      description: 'Lister les promotions de vidéos',
    },
    'video_promotion.edit': {
      title: 'Éditer',
      description: 'Créer et éditer les promotions de vidéos',
    },
    'file_copy.read': {
      title: 'Voir',
      description: 'Lister les opérations de copies de fichiers',
    },
    'file_copy.edit': {
      title: 'Éditer',
      description: 'Lancer et gérer les opérations de copies de fichiers',
    },
    'media_uploader.access': {
      title: 'Media Uploader',
      description: 'Accéder au Media Uploader',
    },
    'media_uploader.cold_storage_access': {
      title: 'Media Uploader - Cold Storage',
      description: 'Accéder aux fichiers stockés en Cold Storage',
    },
    'content_id.edit': {
      title: 'Content ID',
      description: "Autoriser le dépôt d'empreinte de protection via le Content ID",
    },
    'dataviz.read': {
      title: 'Performance - Voir',
      description: 'Voir et utiliser la section Performance',
    },
    'roles.read': { title: 'Voir', description: 'Lister les rôles et leurs permissions' },
    'roles.edit': {
      title: 'Éditer',
      description:
        'Éditer les rôles (et modifier les permissions de tous les utilisateurs ayant ce rôle)',
    },
    'scam_export.read': {
      title: 'SCAM - Voir',
      description: 'Accès aux exports SCAM',
    },
    'youtubeQuotas.read': {
      title: 'Quotas YouTube - Voir',
      description: 'Accès aux quotas YouTube API',
    },
    'users.edit': {
      title: 'Créer / Éditer',
      description: 'Créer et éditer les utilisateurs',
    },
    'user_roles.read': {
      title: 'Rôles - Voir',
      description: 'Lister les rôles associés aux utilisateurs',
    },
    'user_rights.edit': {
      title: 'Rôles et périmètres - Éditer',
      description: 'Éditer les rôles et périmètres associés aux utilisateurs',
    },
  },
  rolesPermissionsGroups: {
    artworks: 'Œuvres',
    beneficiaries: 'Ayants-droits',
    catalog: 'Catalogue',
    compilations: 'Compilations',
    exports: 'Exports',
    quotas: 'Quotas',
    reports: 'Rapports de vente',
    statements: 'Statements',
    automatedTreatments: 'Traitements auto.',
    videoPromotions: 'Promotions de vidéos',
    fileCopy: 'Copies de fichiers',
    users: 'Utilisateurs',
    products: 'Collections',
    roles: 'Rôles',
    others: 'Autres',
    youtubeChannels: 'Chaînes Youtube',
    youtubeClaimsAssets: 'Claims Youtube',
  },
  placeholders: {
    permissions: 'Veuillez sélectionner une/des permission(s)',
  },
  confirm: {
    wantToDeleteRole: 'Êtes-vous sûr de vouloir supprimer ce rôle ?',
    wantToDisableUser: 'Êtes-vous sûr de vouloir désactiver cet utilisateur ?',
  },
  success: {
    userUpdate: {
      title: "Modification d'utilisateur",
      message: "L'utilisateur a bien été modifié.",
    },
    userDeactivate: {
      title: "Désactivation d'utilisateur",
      message: "L'utilisateur a bien été désactivé.",
    },
    roleUpdate: {
      title: 'Modification de rôle',
      message: 'Le rôle a bien été modifié.',
    },
    roleDelete: {
      title: 'Suppression de rôle',
      message: 'Le rôle a bien été supprimé.',
    },
  },
  errors: {
    userUpdate: {
      title: "Modification d'utilisateur",
      message: "L'utilisateur n'a pas pu être modifié.",
    },
  },
}
